var render = function render(){var _vm=this,_c=_vm._self._c;return _c('image-layout-component',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"content"},[_c('i',{staticClass:"icon-check-circle"}),_c('div',{staticClass:"message"},[_c('p',[_vm._v(" Cadastramento feito com sucesso! ")]),_c('p',[_vm._v(" Você pode fechar essa página e voltar para o sistema. ")])])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }